import markUrl from '@src/assets/autoorbit-mark.svg';
import { cn } from '@src/components/ui';
import { useSidebar } from '@src/context/hooks';


function SidebarContainer(props) {
  const { className, children, ...restProps } = props;
  const { isCollapsed } = useSidebar();

  return (
    <div className={cn('flex h-full flex-col gap-2.5 p-3', className)} {...restProps}>
      {/* Brand: the AutoOrbit mark (logo concept — orbit ring around a wheel
          hub) + bold wordmark; same mark as the auth screens. */}
      <div
        aria-label="AutoOrbit"
        className={cn(
          'flex h-10 items-center gap-2 px-1',
          isCollapsed ? 'justify-center px-0' : 'justify-start',
        )}
      >
        <img alt="" src={markUrl} aria-hidden="true" className="size-[26px] shrink-0 rounded-lg" />

        {!isCollapsed
          ? (
            <span className="truncate text-[15px] font-bold text-ink">
              AutoOrbit
            </span>
          )
          : null}
      </div>

      {children}
    </div>
  );
}

SidebarContainer.displayName = 'SidebarContainer';
export default SidebarContainer;
